import React, { FC } from 'react';
import styled from 'styled-components';
import { TabViewMode } from 'core/enums';
import { AlertVariant } from 'models/alert';
import Grid from 'components/UI/Grid';
import { VisibilityControl } from 'components/shared/VisibilityControl';
import AgronomicAlertsTable from './AgronomicAlertsTable';
import LiveMonitoringMap from '../LiveMonitoringMap';
import { MapVisibilityControl } from '../LiveMonitoring.styles';
import AnomalyAlertsTab from './AnomalyAlertsTab';
import TechnicalAlertsTable from './TechnicalAlertsTable';

const Container = styled(Grid)`
  height: 100%;
`;

const TableVisibilityControl = styled(VisibilityControl)`
  height: 100%;
`;

interface LiveMonitoringAlertsProps {
  viewMode: TabViewMode;
  variant: AlertVariant;
}

const LiveMonitoringAlerts: FC<LiveMonitoringAlertsProps> = ({
  viewMode,
  variant,
}) => (
  <Container align="flex-start">
    <TableVisibilityControl visible={viewMode === TabViewMode.Table}>
      {variant === AlertVariant.Technical && <TechnicalAlertsTable />}
      {variant === AlertVariant.Agronomic && <AgronomicAlertsTable />}
      {variant === AlertVariant.Anomaly && <AnomalyAlertsTab />}
    </TableVisibilityControl>
    <MapVisibilityControl visible={viewMode === TabViewMode.Map}>
      <LiveMonitoringMap />
    </MapVisibilityControl>
  </Container>
);

export default LiveMonitoringAlerts;
